import { supabase } from '@/lib/supabase';
import type {
  AIFlag,
  EventType,
  ExtractPrescriptionMedication,
  VitalSigns,
} from '@/types/db';
import type { UploadedAttachment } from './upload';

export interface SaveExtractionInput {
  profileId: string;
  eventId: string;
  eventType: EventType;
  eventDate: string | null;
  doctorName: string | null;
  doctorSpecialty: string | null;
  clinicName: string | null;
  clinicAddress: string | null;
  clinicPhone: string | null;
  insuranceCompany: string | null;
  insuranceClaim: string | null;
  diagnosis: string | null;
  notes: string | null;
  title: string | null;
  vitalSigns?: VitalSigns;
  aiFlags: AIFlag[];
  medications: ExtractPrescriptionMedication[];
  attachments: UploadedAttachment[];
}

export async function saveExtraction(
  input: SaveExtractionInput,
): Promise<string> {
  const payload = {
    p_profile_id: input.profileId,
    p_event_id: input.eventId,
    p_event: {
      event_type: input.eventType,
      title: input.title,
      event_date: input.eventDate,
      doctor_name: input.doctorName,
      doctor_specialty: input.doctorSpecialty,
      clinic_name: input.clinicName,
      clinic_address: input.clinicAddress,
      clinic_phone: input.clinicPhone,
      insurance: {
        ...(input.insuranceCompany ? { company: input.insuranceCompany } : {}),
        ...(input.insuranceClaim ? { claim_number: input.insuranceClaim } : {}),
      },
      diagnosis: input.diagnosis,
      notes: input.notes,
      vital_signs: input.vitalSigns ?? {},
      ai_flags: input.aiFlags,
    },
    p_medications: input.medications.map((m) => ({
      drug_name: m.drug_name,
      dosage: m.dosage,
      frequency: m.frequency,
      duration_days: m.duration_days,
      start_date: input.eventDate ?? null,
    })),
    p_attachments: input.attachments.map((a) => ({
      storage_path: a.storage_path,
      file_type: a.file_type,
      file_name: a.file_name,
    })),
  };

  const { data, error } = await supabase.rpc('save_extraction', payload);
  if (error) throw error;
  return data as string;
}
